import React from 'react';
import { Navigate, useLocation } from 'react-router';

import Authentication from '../components/organisms/Authentication';
import { useAppGlobals } from '../components/contexts/AppContext';

const AuthenticationContainer = () => {
  const { search } = useLocation();
  const { user } = useAppGlobals();
  const searchParams = new URLSearchParams(search);
  const redirectPath = searchParams.get('redirect') || '/';

  if (user) {
    // For logged in users, the login page is not available
    return <Navigate to={redirectPath} />;
  }

  return <Authentication user={user} />;
};

export default AuthenticationContainer;
